
/**
 * Created by Alex Xia on 03/29/21.
 * Description:
 * base class of auto complete
 * ------ maintenance history ------
 */
import { Observable, Subject, Subscription } from 'rxjs';
import { ContactService } from '@tamalelibs/services/contact.service';
import { DashboardTileService } from '../../dashboard-tile.service';
import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { Contact } from '@tamalelibs/models/contact.model';
import { MapContactModel } from './tam-dashboard-map-autocomplete.model';
import { debounceTime, switchMap } from 'rxjs/operators';
import { businessConstants } from '../../../../constants/business.constants';
import { Entity } from '@tamalelibs/models/entity.model';
import { ChangeDetectorRef } from '@angular/core';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { getSystemConfigState } from '../../../../redux/reducers/system-config-view.reducer';

@Injectable()
export class DashboardMapAutocompleteBaseComponent {
    @ViewChild('searchAddress', { static: true }) searchAddress: ElementRef;
    predictionArray: Array<MapContactModel> = []; // predictions shown on list
    userInput = ''; // user search text
    isPopUpShow = false;
    isItemDetailShow = false;
    isFocus = false;

    protected subscriptions: Array<Subscription> = [];
    protected element: HTMLElement;
    protected contactArray: Array<MapContactModel> = [];
    protected contacts$: Observable<any>;
    protected subscribed = false;
    protected searchTerms$ = new Subject<string>();
    protected destroySubscriptions: Array<Subscription> = [];


    constructor(
        protected _contactService: ContactService,
        protected _dashboardTileService?: DashboardTileService,
        protected _changeDetectorRef?: ChangeDetectorRef,
        protected _storeQuerier?: StoreQuerierService,
    ) {
    }

    clearInput() {
        this.userInput = '';
        this.isPopUpShow = false;
        this.isItemDetailShow = false;
    }

    onClickOutside(event: Object) {
        if (event && event['value'] === true) {
            this.isPopUpShow = false;
            this.isFocus = false;
        }
    }

    protected _getAllPredicitons() {
        this.predictionArray = [];
        if (this.userInput && this.userInput.length > 0) {
            // get predicit
            this.searchTerms$.next(this.userInput);
            // google api
            if (this._isEnableGoogleMapService()) {
                this._dashboardTileService.getMapSearchPredictions(this.userInput, this, this._getPredictions);
            } else {
                this._getPredictions([]);
            }
        } else {
            this.isPopUpShow = false;
            this.isFocus = !(this.predictionArray && this.predictionArray.length === 0);
        }
    }

    protected _getContacts(response: any) {
        let currentContact: Contact;
        let mapContactModel: MapContactModel;
        this.contactArray = [];
        const tmpContactArray: Array<MapContactModel> = []; // used to store the contacts which return from server
        const contactList = response['entity-list'];
        if (contactList && contactList.length > 0) {
            this.isPopUpShow = true;
            contactList.forEach(contact => {
                const typeName = (contact['entity-type'] && contact['entity-type']['link']) ? contact['entity-type']['link']['phid'] : '';
                currentContact = typeName === businessConstants.addressType.contact ? Contact.parse(contact) : Entity.parse(contact);
                if (currentContact.webAddress && currentContact.webAddress.length > 0) {
                    for (let i = 0; i < currentContact.webAddress.length; i++) {
                        const webAddressItem = currentContact.webAddress[i];
                        if (webAddressItem.country || webAddressItem.state || webAddressItem.street || webAddressItem.street2 || webAddressItem.zip || webAddressItem.city) {
                            mapContactModel = new MapContactModel();
                            mapContactModel.contact = currentContact;
                            mapContactModel.latitude = webAddressItem.latitude || 0;
                            mapContactModel.longitude = webAddressItem.longitude || 0;
                            mapContactModel.selectedAddress = this._dashboardTileService.getAddress(webAddressItem);
                            mapContactModel.entityIndex = i;
                            mapContactModel.selectedAddressType = webAddressItem.name || '';
                            mapContactModel.entityType = typeName;
                            mapContactModel.entityName = currentContact.name;
                            mapContactModel.entityId = currentContact.id;
                            this.contactArray.push(mapContactModel);
                            if (!this.predictionArray.includes(mapContactModel)) {
                                tmpContactArray.push(mapContactModel);
                            }
                        }
                    }
                }
            });
            // Tamale's data needs to be placed on top of the data returned by Google Map
            this.predictionArray = [...tmpContactArray, ...this.predictionArray];
            this.isPopUpShow = true;
            this.isFocus = true;
        }

        // distinct array
        this.predictionArray = Array.from(new Set(this.predictionArray));
        this._changeDetectorRef.detectChanges();
        // solve the issue that the popup won't prompted on contact/entity screen
        setTimeout(() => {
            if (this.searchAddress) {
                this.searchAddress.nativeElement.click();
            }
        }, 200);
    }

    /*
     * call back function for getMapSearchPredictions
    */
    protected _getPredictions(predictions) {
        let mapContactModel: MapContactModel;

        if (predictions && predictions.length > 0) {
            this.isFocus = true;
            this.isPopUpShow = true;
            for (let i = 0; i < 5; i++) {
                mapContactModel = new MapContactModel();
                if (predictions[i]) {
                    mapContactModel.selectedAddress = predictions[i]['description'];
                    if (this.predictionArray.length <= 5) {
                        if (!ArrayHelperService.arrayContains(this.predictionArray, mapContactModel)) {
                            this.predictionArray.push(mapContactModel);
                        }
                    }
                }
            }
        }
    }

    protected _initSubscriptions() {
        if (!this.subscribed) {
            this.subscribed = true;
            this.contacts$ = this.searchTerms$.pipe(
                // wait for 300ms
                debounceTime(300),
                switchMap((address: string) => this._contactService.getContactAndCorporateEntityList(1, 5, address, 'address,long-name,short-name', 'long-name', 'asc')),
            );
            this.destroySubscriptions.push(
                this.contacts$.subscribe(response => this._getContacts(response))
            );
        }
    }

    private _isEnableGoogleMapService() {
        let _isEnableGoogleMapService = false;
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        if (systemConfig && systemConfig.maptile) {
            _isEnableGoogleMapService = systemConfig.maptile['enable'];
        }
        return _isEnableGoogleMapService;
    }
}
